import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Coins } from "lucide-react";
import NotificationBell from "./NotificationBell";
import Logo from "./Logo";

export default function Header({ title, right }) {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-40 glass-strong border-b border-white/5 px-4 py-3 flex items-center justify-between">
      <Link to="/dashboard" className="flex items-center gap-2" data-testid="header-logo">
        <Logo size={28} />
      </Link>
      <div className="flex items-center gap-2">
        {right}
        {user && (
          <div className="chip" style={{ background: "#00FF6615", color: "#00FF66", border: "1px solid #00FF6644" }} data-testid="header-credits">
            <Coins className="w-3 h-3" />
            {(user.fan_credits || 0).toLocaleString("en-IN")}
          </div>
        )}
        {user && <NotificationBell />}
      </div>
    </header>
  );
}
